export default __webpack_public_path__ + "static/media/Classement.69e45115.svg";